'use client';
import InfoCircle from '@/app/_components/ui/icons/InfoCircle.svg';
import React, { useEffect, useState } from 'react';
import PriceUnit from '../share/PriceUnit';
import { useProductContext } from '@/app/_providers/ProductContext';

export default function singleProductPrice() {
  const [percent, setPercent] = useState(0);
  const [profit, setProfit] = useState(0);
  const { currentVariation } = useProductContext();

  useEffect(() => {
    if (currentVariation) {
      let profit = currentVariation.regular - currentVariation.sale;
      let percent = Math.round(
        ((currentVariation.regular - currentVariation.sale) /
          currentVariation.regular) *
          100
      );
      setPercent(percent);
      setProfit(profit);
    }
  }, [currentVariation]);

  if (currentVariation && Object.keys(currentVariation).length > 0) {
    return (
      <div className="spPrice mb-2  pt-5 border-t border-light-gray-150 text-xs md:text-sm text-gray-600">
        <>
          {currentVariation.regular != currentVariation?.sale && (
            <>
              <div className="md:pb-4 pb-3 flex">
                <span> قیمت:</span>
                <div className="text-dark-gray pr-2  font-bold text-sm flex items-center">
                  <div className="flex">
                    <PriceUnit price={currentVariation?.regular} />
                  </div>
                </div>
              </div>

              <div className="md:pb-4 pb-3 flex">
                <span> سود شما از این خرید:</span>
                <div className="text-dark-gray pr-2 text-sm font-bold  flex items-center">
                  <span className="pl-1 flex">
                    <PriceUnit price={profit} />
                  </span>

                  <span className="onsale bg-color-discount text-white rounded-md py-0.5 px-2 text-sm mr-2 flex items-center">
                    {percent}%
                  </span>
                </div>
              </div>
            </>
          )}
          <div className="md:pb-4 pb-3 flex items-center">
            <span>قیمت نهایی:</span>
            <div className="text-dark-gray pr-2  text-sm md:text-xl font-bold  flex items-center">
              <PriceUnit price={currentVariation?.sale} />
            </div>
          </div>
          {currentVariation.description && (
            <div className="md:pb-4 pb-3  flex items-center">
              <div className="font-bold flex bg-canceld-light p-2 rounded-md w-full">
                <InfoCircle fill="#F17603" />
                <span className="text-canceled-heavy pr-2 text-sm">
                  {currentVariation.description}
                </span>
              </div>
            </div>
          )}
        </>
      </div>
    );
  }
}
